import { useEffect, useState } from 'react';
import { Button } from '../Base/Button';
import { ModalBase } from './Base';

export function ClaimPointsConfirmation({
  callBackFn,
  closeModal,
}: {
  callBackFn: () => void;
  closeModal: () => void;
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const storedPreference = localStorage.getItem('dontShowClaimPointsModal');
    if (storedPreference === 'true') {
      closeModal();
    }
  }, [closeModal]);

  const handleDontShowAgain = () => {
    setDontShowAgain(!dontShowAgain);
  };

  const handleConfirm = () => {
    if (dontShowAgain) {
      localStorage.setItem('dontShowClaimPointsModal', 'true');
    }
    callBackFn();
    closeModal();
  };

  return (
    <ModalBase
      isOpen
      size={'md'}
      closeModal={closeModal}
      title={'Confirm claim'}
    >
      <div
        className={`section-container py-5 sm:py-10 sm:px-14 px-5 relative border-primary border-1`}
      >
        <div className="grid grid-cols-1 gap-10 w-full">
          <div className="flex flex-col gap-4 text-white">
            <div className="sm:w-[100%] !mb-10">
              <div>
                You will see two transactions pop up. The first one is to
                transfer points from your wallet to your selected card and the
                second one is to allow your card to receive the points and
                update your card.
              </div>
            </div>
            <Button
              className="app-tab-button app-loader-button bg-green font-medium md:col-span-2 !px-2 !py-1 text-sm"
              onClick={handleConfirm}
            >
              CONFIRM
            </Button>
            <div className="flex items-center mt-4">
              <input
                type="checkbox"
                id="dont-show-again"
                checked={dontShowAgain}
                onChange={handleDontShowAgain}
                className="mr-2"
                style={{ marginRight: '8px' }}
              />
              <label htmlFor="dont-show-again" className="text-white">
                <span> </span>Don't show again
              </label>
            </div>
          </div>
        </div>
      </div>
    </ModalBase>
  );
}
